/**
 * Self-hosted party where music comes from a peer in the conference.
 */

import { Button, Classes, Intent, NonIdealState } from "@blueprintjs/core";
import classNames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { JitsiManager } from "./data";

import { Configuration } from "../common";
import DanceFloor from "./DanceFloor";
import styles from "./Party.module.css";

interface PartyState {
    roomName?: string;
    hasEntered: boolean;
    isHost: boolean;
    useHighQualityAudio: boolean;
}

@observer
export default class extends React.Component<{}, never> {
    public readonly displayName = "Party";

    @observable
    private party: PartyState = {
        hasEntered: false,
        isHost: false,
        useHighQualityAudio: true,
    };

    public constructor(props: {}, context: any) {
        super(props, context);
        if (typeof window !== "undefined") {
            const urlSearchParams = new URLSearchParams(window.location.search.slice(1));

            this.party.isHost = urlSearchParams.has("host") ?? false;
            this.party.useHighQualityAudio = urlSearchParams.get("useHighQualityAudio") === "false" ? false : true;

            urlSearchParams.forEach((value, key) => {
                if (key === "room") {
                    this.party.roomName = value.toLowerCase();
                }
            });
        }
    }

    public componentDidMount() {
        const { roomName } = this.party;
        if (typeof document !== "undefined") {
            document.title =
                roomName === undefined ? Configuration.DEFAULT_DOCUMENT_TITLE : `digital dance hall: ${roomName}`;
        }
    }

    public render() {
        const { hasEntered, roomName } = this.party;

        return (
            <div className={styles.container}>
                {hasEntered && roomName !== undefined ? (
                    <JitsiManager {...this.party} roomName={roomName}>
                        {(props) => <DanceFloor {...props} />}
                    </JitsiManager>
                ) : (
                    this.renderLandingPage()
                )}
            </div>
        );
    }

    private renderLandingPage() {
        return (
            <div className={classNames(styles.landingPage, Classes.DARK)}>
                <NonIdealState
                    title="👋 welcome to digital dance hall 🎉"
                    icon="globe-network"
                    description={
                        <Button
                            text="dancers to the front"
                            intent={Intent.SUCCESS}
                            outlined={true}
                            rightIcon="arrow-right"
                            onClick={() => (this.party.hasEntered = true)}
                            large={true}
                        />
                    }
                />
            </div>
        );
    }
}
